'use es6';

const noop = () => ({});
export default noop;